import React, { useEffect, useState } from 'react';
import { Grid, Button } from '@mui/material'
import { useDispatch } from 'react-redux';
import moment from 'moment'
import 'moment/locale/ru';
import { getUseToolById } from '../../../../api/doc'
import GridProps from '../../../../components/GridProps'
import { fetchDispath } from '../../../../functions/fetch'
import DescriptionIcon from '@mui/icons-material/Description';
import { Chip, Dialog, DialogContent } from '@mui/material';
import FileViewer from '../../../../components/fileViewer/FileViewer';

export default function UseToolById({ history, match }) {
  const [obj, setObj] = useState({
    id: '',
    date: '',
    inventory: '',
    user: '',
    worker: '',
    position: '',
    files:[],
    note:'',
  })
  const { id, idProject } = match.params
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchDispath({
      param: {
        id: id,
        idProject: idProject,
      },
      progress: true,
      request: getUseToolById,
    }))
      .then(res => {
        if (res.success) {
          setObj({
            id: res.get.id,
            date: moment(res.get.date).format('LLL'),
            inventory: res.get.inventoryNumber.toString().padStart(5, '0') + ' ' + res.get.inventoryName,
            user: res.get.gSurname + ' ' + res.get.gName,
            worker: res.get.surname + ' ' + res.get.name[0] + '.' + res.get.patronymic[0] + '.',
            position: res.get.position,
            files:res.get.files,
            note:res.get.note
          })
        }
      }).catch(err => console.log(err))
  }, [dispatch, id, idProject])
  return <div className='App-paper'>
    <Grid
      item
      container
      xs={9}
    >
      <GridProps name='Оборудование' value={obj.inventory} />
      <GridProps name='Выдал' value={obj.user} />
      <GridProps name='Получил' value={obj.worker} />
      <GridProps name='Должность' value={obj.position} />
      <GridProps name='Дата' value={obj.date} />
      <GridProps name='Примечание' value={obj.note} />
    </Grid>
    {obj.files.length>0&&<ListFiles arrFile={obj.files}/>}
    <Button color="primary" onClick={() => history.goBack()}>Назад </Button>
  </div>
}

function ListFiles({ arrFile }) {
  const [open, setOpen] = useState(false)
  const [file, setFile] = useState({ type: '', fileName: '' })
  const handleClick = (obj) => {
    if (obj.name === file.fileName && open) {
      setOpen(false);
      return;
    }
    setFile({ type: (obj.type !== 'xls') ? obj.type : 'xlsx', fileName: obj.name })
    setOpen(true);
    return;
  }
  return <div>
    {arrFile.map(obj => {
      return <Chip
        key={obj.id}
        icon={<DescriptionIcon />}
        label={obj.name}
        onClick={() => handleClick(obj)}
      />
    })}
    <Dialog
      open={open}
      maxWidth={'lg'}
      keepMounted
      fullWidth
      scroll="paper"
      onClose={() => setOpen(false)}
    >
      <DialogContent >
        {open&&<FileViewer
          fileType={file.type}
          fileName={file.fileName}
        />}
      </DialogContent>
    </Dialog>
  </div>
}